import store from '../configureStore';
import { convertObjectBodyString, apiGet, apiPost } from './apiUtil';

export const getProjectById = (projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const getProjectByIdInit = {
    headers: header,
  };

  return apiGet(
    `/project/${projectId}?gid=${currentUserGroup}`,
    getProjectByIdInit,
  );
};

export const getFilesForProject = (projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const getFilesForProjectInit = {
    headers: header,
  };
  return apiGet(
    `/resource-by-parent/${projectId}?gid=${currentUserGroup}`,
    getFilesForProjectInit,
  );
};

export const getFilesForProjectByType = (projectId: string, fileType: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const getFilesForProjectInit = {
    headers: header,
  };
  if (fileType !== 'allfiles') {
    return apiGet(
      `/resource-by-parent/${projectId}?gid=${currentUserGroup}&type=${fileType}`,
      getFilesForProjectInit,
    );
  }

  return apiGet(
    `/resource-by-parent/${projectId}?gid=${currentUserGroup}`,
    getFilesForProjectInit,
  );
};

export const addProject = (data: Record<string, unknown>) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const addProjectInit = {
    headers: header,
    body: convertObjectBodyString(data),
  };
  return apiPost(`/project/add?gid=${currentUserGroup}`, addProjectInit);
};

export const renameItem = (id: string, title: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();

  const espacedTitle = encodeURIComponent(title);

  const updateProjectInit = {
    headers: header,
    body: `id=${id}&title=${espacedTitle}`,
  };
  return apiPost(
    `/project/update?gid=${currentUserGroup}`,
    updateProjectInit,
  );
};

export const updateItemCover = (id: string, storageResponse: { key: string }) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
    user: { identityId },
  } = store.getState();
  const resourceS3Path = `private/${identityId}/${storageResponse.key}`;
  const updateProjectInit = {
    headers: header,
    body: `id=${id}&image=${resourceS3Path}`,
  };
  return apiPost(
    `/project/update?gid=${currentUserGroup}`,
    updateProjectInit,
  );
};

export const updateProjectImage = (id: string, title: string, storagedImageKey: string, name: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
    user: { identityId },
  } = store.getState();
  const imageS3Path = `private/${identityId}/${storagedImageKey}`;
  const updateProjectInitBody = `id=${id}&title=${title}&image=${imageS3Path}&name=${name}`;
  const updateProjectInit = {
    headers: header,
    body: updateProjectInitBody,
  };
  return apiPost(
    `/project/update?gid=${currentUserGroup}`,
    updateProjectInit,
  );
};

export const removeCoverImage = (id: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const updateProjectInitBody = `id=${id}&image=no-image`;
  const updateProjectInit = {
    headers: header,
    body: updateProjectInitBody,
  };
  return apiPost(
    `/project/update?gid=${currentUserGroup}`,
    updateProjectInit,
  );
};

export const getGuestUser = (hash: string) => {
  const {
    project: { header },
  } = store.getState();
  const init = {
    headers: header,
  };
  return Promise.allSettled([
    apiGet(`/guest/user/${hash}`, init),
    apiGet(`/guest/user/all/${hash}`, init),
    apiGet(`/guest/project/${hash}`, init),
    apiGet(`/guest/message/${hash}`, init),
    apiGet(`/guest/task/${hash}`, init),
    apiGet(`/guest/resource/${hash}`, init),
  ]);
};

export const setGuestUsername = (hash: string, firstname: string, lastname: string) => {
  const {
    project: { header },
  } = store.getState();
  const init = {
    headers: header,
  };
  return apiGet(
    `/guest/user/${hash}?firstname=${firstname}&lastname=${lastname}`,
    init,
  );
};
